import { render } from "./EventFeed.vue?vue&type=template&id=8dcd9448&ts=true"
import script from "./EventFeed.vue?vue&type=script&lang=ts"
export * from "./EventFeed.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/levelpro-feed-widget/levelpro-feed-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__